import z from "zod";
import { getDefaultPeriodFilterString } from "@/utils";
import { optionalFilterString } from "@/schemas/filter.schema";

export type TripsFilters = z.infer<typeof tripsFiltersSchema>;

export const tripsFiltersSchema = z.object({
	period: z.string().default(getDefaultPeriodFilterString()),
	search: optionalFilterString,
	clientName: optionalFilterString,
});
